import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default class Speciality extends PureComponent {
  static propTypes = {
    active: PropTypes.bool.isRequired,
    setSpeciality: PropTypes.func.isRequired,
    speciality: PropTypes.object.isRequired,
  };

  render() {
    const { active, speciality, setSpeciality } = this.props;

    return (
      <button
        className={classnames('grid-selection-item', active && 'selected')}
        onClick={() => setSpeciality(speciality)}
      >
        <span>{speciality.name}</span>
      </button>
    );
  }
}
